<template>
<div>
    <Breadcrumbs main="Admin" title="Course Edit" />
    <!-- Container-fluid starts-->
    <div class="container-fluid">
        <div class="row">
            <div class="col-sm-12">
                <px-card>
                    <div slot="with-padding">
                        <div class="form theme-form">
                            <div class="row">
                                <div class="col-sm-12">
                                    <div class="form-group">
                                        <label>Title</label>
                                        <input class="form-control" type="text" placeholder="Enter course title" v-model="course.title">
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-sm-6">
                                    <div class="form-group">
                                        <label>Category</label>
                                        <select class="form-control digits" v-model="course.category" @change="onCategoryChange(course.category)">
                                            <option disabled value="">Select a category</option>
                                            <option v-for="(type, index) in category_parent" :key="index" :value="type.id">{{ type.title }}</option>
                                        </select>
                                    </div>
                                </div>
                                <div class="col-sm-6">
                                    <div class="form-group" v-if="category_list_by_parent && category_list_by_parent?.length">
                                        <label>Sub Category</label>
                                        <select class="form-control digits" v-model="course.sub_category">
                                            <option disabled value="">Select a category</option>
                                            <option v-for="(type, index) in category_list_by_parent" :key="index" :value="type.id">{{ type.title }}</option>
                                        </select>
                                    </div>
                                    <div class="form-group" v-else>
                                        <label>Sub Category</label>
                                        <select class="form-control digits" v-model="course.sub_category">
                                            <option disabled value="">Select a category</option>
                                            <option v-for="(type, index) in category_list" :key="index" :value="type.id">{{ type.title }}</option>
                                        </select>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-sm-6">
                                    <div class="form-group">
                                        <label>Link</label>
                                        <input class="form-control" type="text" placeholder="Enter course link" v-model="course.link">
                                    </div>
                                </div>
                                <div class="col-sm-6">
                                    <div class="form-group">
                                        <label>Own Course?</label>
                                        <select class="form-control" v-model="course.own_asset">
                                            <option :value="true">Yes</option>
                                            <option :value="false">No</option>
                                        </select>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-sm-6" v-if="course.own_asset === false">
                                    <div class="form-group">
                                        <label>Partner</label>
                                        <select class="form-control digits" v-model="course.partner">
                                            <option disabled value="">Select a partner</option>
                                            <option v-for="(type, index) in partner_list" :key="index" :value="type.id">{{ type.title }}</option>
                                        </select>
                                    </div>
                                </div>
                                <div class="col-sm-6">
                                    <div class="form-group">
                                        <label>Coin Cost</label>
                                        <input class="form-control" type="number" placeholder="Enter course coin cost" v-model="course.coin_cost">
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-sm-12">
                                    <div class="form-group">
                                        <label>Trailer Link</label>
                                        <input class="form-control" type="text" placeholder="Enter trailer youtube link" v-model="course.trailer_link">
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-sm-12">
                                    <div class="form-group">
                                        <label>Description</label>
                                        <textarea class="form-control" placeholder="Enter course description" v-model="course.description" rows="4"></textarea>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-sm-12">
                                    <div style="display: flex; flex-direction: column;">
                                        <label>Thumbnail Image</label>
                                        <input type="file" accept="image/*" @change="onImageChange($event, 'thumbnail')" />
                                    </div>
                                    <div v-if="thumbnailPreview">
                                        <img :src="thumbnailPreview" alt="Thumbnail Preview" style="max-width: 100%; max-height: 100px; margin-top: 8px;" />
                                    </div>
                                </div>
                                <div class="col-sm-12" style="margin-top: 20px;">
                                    <div style="display: flex; flex-direction: column;">
                                        <label>Banner Image</label>
                                        <input type="file" accept="image/*" @change="onImageChange($event, 'banner')" />
                                    </div>
                                    <div v-if="bannerPreview">
                                        <img :src="bannerPreview" alt="Banner Preview" style="max-width: 100%; max-height: 100px; margin-top: 8px;" />
                                    </div>
                                </div>
                            </div>

                            <h6 style="margin-bottom: 12px; margin-top: 32px;">Resources</h6>
                            <div v-for="(res, index) in course.resources" :key="index">
                                <div class="row" style="gap: 16px;">
                                    <div class="col-md-4">
                                        <div class="form-group">
                                            <label>Link</label>
                                            <input type="text" class="form-control" v-model="res.link" placeholder="Enter link..." />
                                        </div>
                                    </div>

                                    <div class="col-md-4">
                                        <div class="row">
                                            <div class="col-12">
                                                <div class="form-group d-flex flex-column">
                                                    <label>Image</label>
                                                    <input type="file" class="mt-1" accept="image/*" @change="onFileChange($event, index)" />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-md-2 d-flex align-items-center" style="gap:16px">
                                        <feather type="delete" size="22px" style="color: #ef4444; cursor: pointer;" v-b-tooltip.hover title="Delete" @click="removeResources(index)"></feather>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-6 d-flex align-items-end" style="gap:16px">
                                    <feather type="plus" size="22px" style="color: #2563eb; cursor: pointer;" v-b-tooltip.hover title="Add more" @click="addResources"></feather>
                                </div>
                            </div>

                            <h6 style="margin-bottom: 12px; margin-top: 32px;">You'll Learn</h6>
                            <div v-for="(learn, index) in course.learnigs" :key="index">
                                <div class="row" style="gap: 16px;">
                                    <div class="col-md-4">
                                        <div class="form-group">
                                            <label>Title</label>
                                            <input type="text" class="form-control" v-model="learn.title" placeholder="Enter title..." />
                                        </div>
                                    </div>
                                    <div class="col-md-2 d-flex align-items-center" style="gap:16px">
                                        <feather type="delete" size="22px" style="color: #ef4444; cursor: pointer;" v-b-tooltip.hover title="Delete" @click="removeLearnings(index)"></feather>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-6 d-flex align-items-end" style="gap:16px">
                                    <feather type="plus" size="22px" style="color: #2563eb; cursor: pointer;" v-b-tooltip.hover title="Add more" @click="addLearnings"></feather>
                                </div>
                            </div>

                            <h6 style="margin-bottom: 12px; margin-top: 32px;">Skills You'll Gain</h6>
                            <div v-for="(skill, index) in course.skills" :key="index">
                                <div class="row" style="gap: 16px;">
                                    <div class="col-md-4">
                                        <div class="form-group">
                                            <label>Title</label>
                                            <input type="text" class="form-control" v-model="skill.title" placeholder="Enter title..." />
                                        </div>
                                    </div>
                                    <div class="col-md-2 d-flex align-items-center" style="gap:16px">
                                        <feather type="delete" size="22px" style="color: #ef4444; cursor: pointer;" v-b-tooltip.hover title="Delete" @click="removeSkills(index)"></feather>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-6 d-flex align-items-end" style="gap:16px">
                                    <feather type="plus" size="22px" style="color: #2563eb; cursor: pointer;" v-b-tooltip.hover title="Add more" @click="addSkills"></feather>
                                </div>
                            </div>

                            <h6 style="margin-bottom: 12px; margin-top: 32px;">Tools You'll Learn</h6>
                            <div v-for="(tool, index) in course.tools" :key="index">
                                <div class="row" style="gap: 16px;">
                                    <div class="col-md-4">
                                        <div class="form-group">
                                            <label>Title</label>
                                            <input type="text" class="form-control" v-model="tool.title" placeholder="Enter title..." />
                                        </div>
                                    </div>
                               
                                    <div class="col-md-2 d-flex align-items-center" style="gap:16px">
                                        <feather type="delete" size="22px" style="color: #ef4444; cursor: pointer;" v-b-tooltip.hover title="Delete" @click="removeTools(index)"></feather>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-6 d-flex align-items-end" style="gap:16px">
                                    <feather type="plus" size="22px" style="color: #2563eb; cursor: pointer;" v-b-tooltip.hover title="Add more" @click="addTools"></feather>
                                </div>
                            </div>

                            <div class="row" style="margin-top: 20px;">
                                <div class="col">
                                    <div class="form-group mb-0">
                                        <button @click="onSubmit" class="btn btn-success mr-3" :disabled="isDisabled">Update</button>
                                        <router-link to="/course/list">
                                            <button class="btn btn-danger" href="#">Go Back</button>
                                        </router-link>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </px-card>
            </div>
        </div>
    </div>
    <!-- Container-fluid Ends-->
</div>
</template>

<script>
import {
    mapState
} from 'vuex';
import Datepicker from 'vuejs-datepicker';
import vue2Dropzone from 'vue2-dropzone';
import 'vue2-dropzone/dist/vue2Dropzone.min.css';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import 'sweetalert2/src/sweetalert2.scss';
import Multiselect from 'vue-multiselect';
import 'sweetalert2/src/sweetalert2.scss';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import {
    myHost
} from '../../../../_helpers/host';

export default {
    components: {
        vueDropzone: vue2Dropzone,
        Datepicker,
        Multiselect
    },

    data() {
        return {
            host: myHost.host,
            isDisabled: false,
            editor: ClassicEditor,
            course: {
                title: "",
                category: null,
                sub_category: null,
                link: "",
                trailer_link: "",
                partner: null,
                own_asset: false,
                coin_cost: 0,
                description: "",
                thumbnail: null,
                banner: null,
                resources: [],
                learnigs: [],
                skills: [],
                tools: []
            },
            thumbnailPreview: null,
            bannerPreview: null
        };
    },

    computed: {
        ...mapState({
            course_detail: state => state.course.course_detail,
            partner_list: state => state.partner.partner,
            category_list: state => state.course.category,
            category_parent: state => state.course.category_parent,
            category_list_by_parent: state => state.course.category_list_by_parent
        })
    },

    mounted() {
        this.$store.dispatch("course/fetchCourseDetail", this.$route.params.slug)
        this.$store.dispatch("course/fetchCategoryParent")
        this.$store.dispatch("course/fetchCategory")
        this.$store.dispatch("partner/fetchPartner")
    },

    watch: {
        course_detail: {
            handler(newVal) {
                this.course = { ...newVal }
                this.course.category = newVal.category.id
                this.course.sub_category = newVal.sub_category.id
                this.course.own_asset = newVal.own_asset
                this.course.partner = newVal.partner.id
                this.thumbnailPreview = this.host + newVal.thumbnail
                this.bannerPreview = this.host + newVal.banner
                this.course.thumbnail = null
                this.course.banner = null
            },
            deep: true
        }
    },

    methods: {
        onCategoryChange(id) {
            this.$store.dispatch("course/fetchSubCategory", id)
        },

        onImageChange(e, type) {
            const image = e.target.files[0];
            const reader = new FileReader();
            reader.readAsDataURL(image);
            reader.onload = e => {
                if(type == 'thumbnail') {
                    this.course.thumbnail = e.target.result;
                    this.thumbnailPreview = e.target.result;
                } else {
                    this.course.banner = e.target.result;
                    this.bannerPreview = e.target.result;
                }
            };
        },

        addResources() {
            this.course.resources.push({
                thumbnail: "",
                link: "",
            });
        },

        removeResources(index) {
            this.course.resources.splice(index, 1);
        },

        addLearnings() {
            this.course.learnigs.push({
                title: ""
            });
        },

        removeLearnings(index) {
            this.course.learnigs.splice(index, 1);
        },

        addSkills() {
            this.course.skills.push({
                title: ""
            });
        },

        removeSkills(index) {
            this.course.skills.splice(index, 1);
        },

        addTools() {
            this.course.tools.push({
                title: ""
            });
        },

        removeTools(index) {
            this.course.tools.splice(index, 1);
        },

        onFileChange(event, index) {
            const image = event.target.files[0];
            if (!image) return;
            const reader = new FileReader();
            reader.readAsDataURL(image);
            reader.onload = e => {
                this.course.resources[index].thumbnail = e.target.result;
            };
        },

        onSubmit() {
            this.$store.dispatch("course/updateCourse", {
                slug: this.$route.params.slug,
                course: this.course
            }).then(response => {
                if (response.code == 200) {
                    Swal.fire({
                        title: "Success!",
                        text: response.response,
                        icon: "success"
                    });
                    // this.$store.dispatch("course/fetchCourse")
                    this.resetModal();
                    setTimeout(() => {
                        this.$router.push("/course/list");
                    }, 2000);
                } else {
                    Swal.fire({
                        title: "Error!",
                        text: response.response,
                        icon: "error"
                    });
                }
            })
        },

        resetModal() {
            this.course = {
                title: "",
                category: null,
                sub_category: null,
                link: "",
                trailer_link: "",
                partner: null,
                own_asset: false,
                coin_cost: 0,
                description: "",
                thumbnail: null,
                banner: null,
                resources: [],
                learnigs: [],
                skills: [],
                tools: []
            };
            this.thumbnailPreview = null;
            this.bannerPreview = null;
        }
    }
};
</script>
